import {FaTimes} from 'react-icons/fa'
import playersJSON from '../data/teams.json'
import {useState} from 'react'
const SearchBar =({setOpened, setNewPlayer})=>{

    const [playersFilter, setPlayersFilter] = useState([])
    const [wordFilter, setWordFilter] = useState('')

    //changing the search results by search
    const changeFilter = (e) =>{

        
        const newFilter = e.target.value
        setWordFilter(newFilter)
        
        const filteredPlayer = playersJSON.players.filter((player)=>
        player.name.toLowerCase().includes(newFilter.toLowerCase()) || 
        
        player.positions.map(position => position.toLowerCase()).includes(newFilter.toLowerCase()) || (player.team.name.toLowerCase().includes(newFilter.toLowerCase())) || (player.team.conference.toLowerCase().includes(newFilter.toLowerCase())) 
        
        )
       
        if(newFilter === '') {
            setPlayersFilter([])
        }   
        else{
           
            setPlayersFilter(filteredPlayer)
        }
    }

    const setOpen =(player)=>{
        setOpened(true)
        setNewPlayer(player)
    }
    //clear search bar text by clear button 
    const clearText = ()=>{
        setPlayersFilter([])
        setWordFilter('')
    }
    return(
        <div id="searchBar-container">
            
                <div id='search-container'>
                    <input type="text" onChange={changeFilter} placeholder="Search NBA players, teams, conferences, pos.." value={wordFilter}/>
                    <FaTimes style={closeStyle} onClick={clearText}/>
                </div>
                {
                playersFilter.length !== 0 && (
                <div id='search-results'>
                    {
                        //could use a slice function to print out a certain amount of players
                       (playersFilter.map((player)=>
                            <div id='player-search' onClick={()=>setOpen(player)} >{player.name}</div>
                        ))
                    }
                </div>
                )}
        </div>
    )

}

const closeStyle = {
    
    position:"relative", left:'-25', top:'13',
    color: 'hsl(258, 59%, 94%)' ,
    padding: '5px', borderRadius: '50%', 
    backgroundColor:'#333333', 
    cursor:"pointer",
    
}

export default SearchBar